import React from 'react'
import { __ } from 'StylistParent/i18n';

// import { mediaUpload } from 'StylistParent/utils/mediaupload';
import MediaUpload from './media-upload';
import Button from 'Components/button';

/* Import CSS */
import './index.scss'

class UploadButton extends React.Component {
	componentDidMount = () => {
		const { attributes, setAttributes } = this.props;
	}

	onSelectImage = ( media ) => {
		this.props.changeValue( 'url("' + media.url + '")' )
	}

	render() {
		const { value } = this.props;
		return (
			<div>
				<MediaUpload
					onSelect={ this.onSelectImage }
					type="image"
					value={ value }
					render={ ( { open } ) => (
						<Button onClick={ open } className="button-primary button-large">
							{ __( 'Open Media Library' ) }
						</Button>
					) }
				/>
			</div>
		)
	}
}

export default UploadButton;



// WEBPACK FOOTER //
// ./dev/stylist_parent/components/upload-button/index.jsx